import React from 'react';
import CategoryCard from "../domain/category/ui/CategoryCard/CategoryCard";

const CategoryPage = () => {
    return (
       <CategoryCard />
    );
};

export default CategoryPage;